import {
    apiRequest,
    cutiListBawahan,
    listAtasan
} from "../../../../../../services/adapters/kepegawaian/cutiService"
import {
    apiRequest as positionApiRequest,
    positionDetail
} from "../../../../../../services/adapters/master/positionService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", cutiListBawahan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchAtasan = async (query, cancelToken) => {
        return await apiRequest("get", listAtasan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    // resolve position_uuid (dari row atasan terpilih, termasuk jabatan Plt/Plh) -> position_work_unit_uuid
    fetchPositionDetail = async (query, cancelToken) => {
        return await positionApiRequest("get", positionDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default DataTableRepository